/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

class NumberHelper {
  static randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  static addZerosUntilLength(number, length) {
    let string = number.toString();
    while (string.length < length) {
      string = '0' + string;
    }
    return string;
  }

  static getBooleanLabel(value, labelForTrue, labelForFalse) {
    return value ? labelForTrue : labelForFalse;
  }
}
export default NumberHelper;
